import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {ApiService} from "../../service/api";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {StateService} from "../../service/state";
import swal from "sweetalert2";

@Component({
    selector: 'fw-contact',
    templateUrl: './contact.html',
    encapsulation: ViewEncapsulation.None
})
export class ContactComponent implements OnInit {
    public contact: FormGroup;

    constructor(public apiService: ApiService, public state: StateService, public fb: FormBuilder, public nav: Router) {
        state.setState('title', 'Kontakt');
    }

    ngOnInit() {
        this.contact = this.fb.group({
            name: ['', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
            nachricht: ['', [Validators.required]]
        });

        this.state.getState('user').then((user) => {
            if (user && user.firstname && user.surname) {
                this.contact.patchValue({
                    name: user.firstname + ' ' + user.surname,
                    email: user.email
                })
            }
        })
    }

    contactSubmit($event) {
        this.apiService.call('/contact/index/index', this.contact.getRawValue()).then((result) => {
            swal({
                title: 'Vielen Dank für Ihre Anfrage!'
            });
            this.nav.navigate(['/']);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/contact/contact.ts